import PropTypes from "prop-types";

import * as React from "react";
import { FormattedMessage } from "react-intl";
import { default as moment } from "moment";
import { SessionStore } from "shared/src/uidispatcherapi/SessionStore";

const deliveryRenderData = (
    deliveryMode: string,
    availability: string,
    delisted: boolean,
    hasDeliveryDate: boolean
) => {
    switch (deliveryMode) {
        case "METRO_DELIVERY":
            return {
                iconClass: "icon-small-truck",
                deliveryClassName: "ex-delivery-metro",
                i18n: delisted
                    ? "EX_STOCK_LABEL_DELISTED"
                    : "EX_STOCK_LABEL_AVAILABILITY_" + availability + (hasDeliveryDate ? "_WITH_DATE" : ""),
                fallbackKey: delisted ? "EX_STOCK_LABEL_DELISTED" : "EX_STOCK_LABEL_AVAILABILITY_" + availability
            };
        case "STORE":
            return {
                iconClass: "icon-small-store",
                deliveryClassName: "ex-delivery-store",
                i18n: delisted ? "EX_STOCK_LABEL_DELISTED" : "EX_STOCK_LABEL_STORE_AVAILABILITY_" + availability
            };
        case "PICKUP":
            return {
                iconClass: "icon-store",
                deliveryClassName: "ex-delivery-pickup",
                i18n:
                    availability === "UNAVAILABLE" ? "EX_STOCK_LABEL_AVAILABILITY_UNAVAILABLE" : "EX_STOCK_LABEL_PICKUP"
            };
        case "PARCEL_DELIVERY":
            return {
                iconClass: "icon-small-truck",
                deliveryClassName: "ex-delivery-parcel",
                i18n:
                    availability === "UNAVAILABLE"
                        ? "EX_STOCK_LABEL_AVAILABILITY_UNAVAILABLE"
                        : // FIXME Quick solution for MSD-2279. But all of this could use a good refactoring.
                          "EX_STOCK_LABEL_DELIVERY" + (availability === "LIMITED" ? "_LIMITED" : ""),
                fallbackKey:
                    availability === "UNAVAILABLE"
                        ? "EX_STOCK_LABEL_AVAILABILITY_UNAVAILABLE"
                        : "EX_STOCK_LABEL_DELIVERY"
            };
        case "EXPRESS_DELIVERY":
            return {
                iconClass: "icon-small-truck",
                deliveryClassName: "ex-delivery-express",
                i18n:
                    availability === "UNAVAILABLE"
                        ? "EX_STOCK_LABEL_AVAILABILITY_UNAVAILABLE"
                        : // FIXME Quick solution for MSD-2279. But all of this could use a good refactoring.
                          "EX_STOCK_LABEL_EXPRESS" + (availability === "LIMITED" ? "_LIMITED" : ""),
                fallbackKey:
                    availability === "UNAVAILABLE"
                        ? "EX_STOCK_LABEL_AVAILABILITY_UNAVAILABLE"
                        : "EX_STOCK_LABEL_EXPRESS"
            };
        default:
            return {};
    }
};

type Props = {
    availability: string;
    deliveryMode: string;
    deliveryDate: Date | undefined | null;
    delisted: boolean;
    storeName: string | undefined | null;
    showComma: boolean;
};

class AvailabilityDetails extends React.Component<Props> {
    static contextTypes = { intl: PropTypes.object.isRequired };

    render() {
        const deliveryMode = this.props.deliveryMode;
        const deliveryDate = this.props.deliveryDate;
        const availability = this.props.availability;

        const renderData = deliveryRenderData(deliveryMode, availability, this.props.delisted, !!deliveryDate);

        const key =
            renderData.i18n! in this.context.intl.messages || !renderData.fallbackKey
                ? renderData.i18n!
                : renderData.fallbackKey;

        let formattedDate = "";
        let dateFormat;

        if (!this.props.delisted && availability !== "UNAVAILABLE" && deliveryMode !== "STORE") {
            let dateFormatKey = key + "_DATE";
            if (!(dateFormatKey in this.context.intl.messages)) {
                dateFormatKey = "EX_STOCK_LABEL_DELIVERY_DATE";
            }
            dateFormat = this.context.intl.messages[dateFormatKey] || "DD-MM-YYYY";
            formattedDate = deliveryDate
                ? moment(deliveryDate).locale(SessionStore.getLocale()).format(dateFormat)
                : "";
        }

        return (
            <span className={renderData.deliveryClassName}>
                <span className={"state " + availability}>
                    <i className={renderData.iconClass} />
                    <span className="bubble icon-bubble" />
                    <span>
                        <FormattedMessage
                            id={key}
                            values={{ date: formattedDate, store: this.props.storeName || "" }}
                        />
                        {this.props.showComma && ", "}
                    </span>
                </span>
            </span>
        );
    }
}

export default AvailabilityDetails;
